import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { VISAS } from "@/data/visas";

export default function VisaSection() {
  return (
    <section
      id="visa-wege"
      data-testid="visa-section"
      className="border-t border-line bg-sand py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-[0.3em] text-clay"
              data-testid="visa-eyebrow"
            >
              Visa &amp; Green Card
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
              data-testid="visa-title"
            >
              Ihr <span className="italic text-clay">Visum</span> für die USA
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-6 text-base leading-relaxed text-ink-muted"
              data-testid="visa-intro"
            >
              Es gibt mehr als einen Weg: Neben dem E-2-Unternehmervisum kommen
              auch direkte Green-Card-Wege wie EB-2 NIW oder EB-1C infrage – und
              für Führungskräfte das L-1A Visum. Wir prüfen ehrlich, welcher Weg
              zu Ihrem Profil passt – und begleiten Ihre Antragstellung
              komplett, von der Vorbereitung bis zur Entscheidung.
            </motion.p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="border-t border-line" data-testid="visa-list">
            {VISAS.map((visa, index) => (
              <motion.li
                key={visa.slug}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: index * 0.08 }}
                className="border-b border-line"
                data-testid={`visa-card-${visa.slug}`}
              >
                <Link
                  to={`/visa/${visa.slug}`}
                  data-testid={`visa-card-link-${visa.slug}`}
                  className="group block py-10 transition-colors hover:bg-sand-deep"
                >
                  <span className="text-xs uppercase tracking-[0.2em] text-clay">
                    {visa.badge}
                  </span>
                  <div className="mt-3 flex items-start justify-between gap-6">
                    <h3 className="font-serif text-2xl tracking-tight text-ink transition-colors group-hover:text-clay sm:text-3xl">
                      {visa.title}
                    </h3>
                    <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-clay transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </div>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-ink-muted md:text-base">
                    {visa.description}
                  </p>
                </Link>
              </motion.li>
            ))}
          </ul>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-10"
          >
            <Link
              to="/visumsberatung-usa"
              data-testid="visa-section-consulting-link"
              className="group inline-flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-clay"
            >
              Zur Visumsberatung USA
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
